import { formValidation } from "./_vendor/@form-validation/esm/bundle/full.min.js";
import { AutoFocus } from "./_vendor/@form-validation/esm/plugin-auto-focus";
import { Message } from "./_vendor/@form-validation/esm/plugin-message";
import { SubmitButton } from "./_vendor/@form-validation/esm/plugin-submit-button";
import { Trigger } from "./_vendor/@form-validation/esm/plugin-trigger";

import {
    DobValidators,
    ValidateDob,
    Messages,
    SetMessageContainer,
    InvalidFieldEventHandler,
    ValidFieldEventHandler,
} from "./_form";
import runRecaptchaAndSubmit from "./_recaptcha.js";

let fv;
let form;
let submitButton;

const initRadioReveal = (name) => {
    // Reveal the target content if there's a pre-selected value on page-load.
    const selectedRadio = form.querySelector(`[data-reveal="${name}"]:checked`);
    if (selectedRadio) {
        // Hide all content divs.
        const contentDivs = form.querySelectorAll(`.js-reveal-${name}`);
        for (let j = 0; j < contentDivs.length; j += 1) {
            contentDivs[j].classList.add("hidden");
        }

        // Reveal the target content div.
        const revealId = selectedRadio.dataset.revealId;
        form.querySelector(`#${revealId}`).classList.remove("hidden");
    }
};

const toggleRadioReveal = (name) => {
    const fields = form.querySelectorAll(`[data-reveal="${name}"]`);
    const contentDivs = form.querySelectorAll(`.js-reveal-${name}`);

    for (let i = 0; i < fields.length; i += 1) {
        fields[i].addEventListener("change", (event) => {
            // Hide all content divs.
            for (let j = 0; j < contentDivs.length; j += 1) {
                contentDivs[j].classList.add("hidden");
            }

            // Reveal the target content div.
            const revealId = event.currentTarget.dataset.revealId;
            form.querySelector(`#${revealId}`).classList.remove("hidden");
        });
    }
};

const toggleBmiCalculatorValidation = (value) => {
    if (value === "yes") {
        // Enable validator on BMI.
        fv.enableValidator("bmi");
        fv.disableValidator("calculated_bmi");
    } else {
        // Enable validator on Calculated BMI.
        fv.disableValidator("bmi");
        fv.enableValidator("calculated_bmi");
    }
};

const toggleMedicalConditionsInfoValidator = (value) => {
    if (value === "yes") {
        fv.enableValidator("medical_conditions_info");
    } else {
        fv.disableValidator("medical_conditions_info");
    }
}

const toggleBeenPregnantInfoValidator = (value) => {
    if (value === "yes") {
        fv.enableValidator("been_pregnant_info");
    } else {
        fv.disableValidator("been_pregnant_info");
    }
}

const revalidateCalculatedBmi = () => {
    fv.revalidateField("calculated_bmi");
};

const validateForm = () => {
    fv = formValidation(form, {
        fields: {
            dob: {
                validators: DobValidators,
            },
            first_name: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            last_name: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            telephone: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            address_1: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            city: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            postcode: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                },
            },
            email: {
                validators: {
                    notEmpty: {
                        message: Messages.default,
                    },
                    emailAddress: {
                        message: Messages.email,
                    },
                },
            },
            preferred_clinic: {
                validators: {
                    notEmpty: {
                        message: Messages.select,
                    },
                },
            },
            know_bmi: {
                validators: {
                    notEmpty: {
                        message: Messages.radio,
                    },
                },
            },
            bmi: {
                validators: {
                    notEmpty: {
                        enabled: false,
                        message: Messages.default,
                    },
                },
            },
            calculated_bmi: {
                validators: {
                    notEmpty: {
                        enabled: false,
                        message: "Please calculate your BMI.",
                    },
                },
            },
            adopted: {
                validators: {
                    notEmpty: {
                        message: Messages.radio,
                    },
                },
            },
            medical_history: {
                validators: {
                    notEmpty: {
                        message: Messages.radio,
                    },
                },
            },
            medical_conditions: {
                validators: {
                    notEmpty: {
                        message: Messages.radio,
                    },
                },
            },
            medical_conditions_info: {
                validators: {
                    notEmpty: {
                        enabled: false,
                        message: Messages.default,
                    },
                },
            },
            smoker: {
                validators: {
                    notEmpty: {
                        message: Messages.radio,
                    },
                },
            },
            been_pregnant: {
                validators: {
                    notEmpty: {
                        message: Messages.radio,
                    },
                },
            },
            been_pregnant_info: {
                validators: {
                    notEmpty: {
                        enabled: false,
                        message: Messages.default,
                    },
                },
            },
            enquiry_source: {
                validators: {
                    notEmpty: {
                        message: Messages.select,
                    },
                },
            },
            data_collection_consent: {
                validators: {
                    notEmpty: {
                        message: Messages.required,
                    },
                },
            },
        },
        plugins: {
            autoFocus: new AutoFocus({
                onPrefocus: function (e) {
                    if (e.field === "date_of_birth") {
                        form.querySelector('[name="date_of_birth_0"]').focus();
                    }
                },
            }),
            message: new Message({
                clazz: "error",
                container: (field, element) => SetMessageContainer(element),
            }),
            submitButton: new SubmitButton(),
            trigger: new Trigger(),
        },
    })
        .on("core.field.invalid", (fieldName) => {
            InvalidFieldEventHandler(fv, fieldName);
        })
        .on("core.field.valid", (fieldName) => {
            ValidFieldEventHandler(fv, fieldName);
        })
        .on("core.form.valid", () => {
            submitButton.setAttribute("disabled", true);
            runRecaptchaAndSubmit(form);
        });

    // Toggle BMI calc. validators if there's a pre-selected value on page-load.
    const selectedRadio = form.querySelector('input[name="know_bmi"]:checked');
    if (selectedRadio) {
        toggleBmiCalculatorValidation(selectedRadio.value);
    }

    // Toggle BMI calc. validators based on change event.
    const radios = form.querySelectorAll('[name="know_bmi"]');
    for (let i = 0; i < radios.length; i += 1) {
        radios[i].addEventListener("change", (e) => {
            toggleBmiCalculatorValidation(e.target.value);
        });
    }

    // Toggle Medical Conditions info validator if there's a pre-selected value on page-load.
    const selectedRadioMedicalConditions = form.querySelector('input[name="medical_conditions"]:checked');
    if (selectedRadioMedicalConditions) {
        toggleMedicalConditionsInfoValidator(selectedRadioMedicalConditions.value);
    }

    // Toggle Medical Conditions Info validator based on change event.
    const radiosMedicalConditions = form.querySelectorAll('[name="medical_conditions"]');
    for (let i = 0; i < radiosMedicalConditions.length; i += 1) {
        radiosMedicalConditions[i].addEventListener("change", (e) => {
            toggleMedicalConditionsInfoValidator(e.target.value);
        });
    }

    // Toggle Pregnancy info validator if there's a pre-selected value on page-load
    const selectedRadioPregnant = form.querySelector('input[name="been_pregnant"]:checked');
    if (selectedRadioPregnant) {
        toggleBeenPregnantInfoValidator(selectedRadioPregnant.value);
    }

    // Toggle Pregnancy Info validator based on change event.
    const radiosPregnant = form.querySelectorAll('[name="been_pregnant"]');
    for (let i = 0; i < radiosPregnant.length; i += 1) {
        radiosPregnant[i].addEventListener("change", (e) => {
            toggleBeenPregnantInfoValidator(e.target.value);
        });
    }

    ValidateDob(form, fv);
};

const ApplicationForm = () => {
    form = document.querySelector(".js-apply");
    if (form === null) {
        return;
    }

    submitButton = form.querySelector('button[type="submit"]');

    initRadioReveal("bmi");
    toggleRadioReveal("bmi");

    initRadioReveal("conditions");
    toggleRadioReveal("conditions");

    initRadioReveal("medical-history");
    toggleRadioReveal("medical-history");

    initRadioReveal("smoker");
    toggleRadioReveal("smoker");

    initRadioReveal("pregnant");
    toggleRadioReveal("pregnant");

    validateForm();
};

export { ApplicationForm, revalidateCalculatedBmi };
